import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { LoginUserInfo } from '@/common/types/login';

interface AuthState {
  user: LoginUserInfo | null;
  setUser: (user: LoginUserInfo | null) => void;
  logout: () => void;
  isEmailVerificationBannerVisible: boolean;
  setEmailVerificationBannerVisible: (visible: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isEmailVerificationBannerVisible: true,
      setUser: (user) => set({ user }),
      logout: () => {
        set({ user: null, isEmailVerificationBannerVisible: true });
      },
      setEmailVerificationBannerVisible: (visible) => set({ isEmailVerificationBannerVisible: visible }),
    }),
    {
      name: 'auth-storage',
    }
  )
);